<template>
  <TitleWrapper class="title" :bgcolor="Color">
    <div class="title-wrapper" :class="TitleClass || 'default-title'">
      <h4><span v-html="TitleCopy"/></h4>
    </div>
  </TitleWrapper>
</template>

<script>
import styled from 'vue-styled-components'
import Color from 'color'
import { colors } from '@/styles/theme'
import * as _ from '@/styles/mixins'

// STYLES
const props = {
  bgcolor: String
}

const TitleWrapper = styled('div', props)`
  ${_.absoluteTopFull};
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  will-change: transform;
  z-index: 100;
  .title-wrapper {
    ${_.absoluteCentered};
    ${_.flexCenteredAll};
    transform-origin: center center;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: visible;
  }
  h4 {
    ${_.flexCenteredAll};
    ${_.absoluteCentered};
    color: ${colors.black}!important;
    background-color: white;
    text-align: center;
    text-transform: uppercase;
    height: 7rem;
    border: 3px solid black;
    transform: scale(.95);
    transition: filter 250ms ease-in-out, transform 25ms ease-in-out;
    filter: drop-shadow(0 0 0px ${props => Color(props.bgcolor).rotate(0)});
    will-change: transform, filter;
    padding: 0;
    width: 100%;
    font-size: 2.125rem;
    span {
      width: 100%;
    }
  }
`

// VUE
export default {
  props: [
    'Color',
    'TitleCopy',
    'TitleClass'
  ],
  components: {
    TitleWrapper
  }
}
</script>
